import './App.css'

import React from 'react';

import MainPage from './components/MainPage';
import Payment from './components/Payment';
import Session from './components/Payment/Session';

import Settings from './components/Settings';
import CartLayouts from './components/CartLayouts';
import NewCartLayoutForm from './components/CartLayouts/NewCartLayoutForm';
import UpdateCartLayoutForm from './components/CartLayouts/UpdateCartLayoutForm';
import Zones from './components/Zones';
import NewZoneForm from './components/Zones/NewZoneForm';
import UpdateZoneForm from './components/Zones/UpdateZoneForm';

import {
  BrowserRouter as Router,
  Route,
  Routes
} from 'react-router-dom';

import '@shoelace-style/shoelace/dist/themes/light.css';
import { setBasePath } from '@shoelace-style/shoelace/dist/utilities/base-path';

setBasePath('https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.19.0/cdn/');

const App = ({ payload, checkoutSessionId }) => {
  return (
    <Router>
      <div>
        <Routes>
          <Route path='/' element={<MainPage payload={payload} checkoutSessionId={checkoutSessionId} />} />
          <Route path='/payment' element={<Payment payload={payload} />} />
          <Route path='/payment_session/:checkoutSessionId' element={<Session payload={payload} />} />
          <Route path='/settings' element={<Settings payload={payload} />} />
          <Route path='/cart_layouts' element={<CartLayouts payload={payload} />} />
          <Route path='/cart_layouts/new' element={<NewCartLayoutForm payload={payload} />} />
          <Route path='/cart_layouts/edit/:id' element={<UpdateCartLayoutForm payload={payload} />} />
          <Route path='/zones' element={<Zones payload={payload} />} />
          <Route path='/zones/new' element={<NewZoneForm payload={payload} />} />
          <Route path='/zones/edit/:id' element={<UpdateZoneForm payload={payload} />} />
          
        </Routes>
      </div>
    </Router>
  )
}

export default App;
